import BaseEntity from "./BaseEntity";
import GameState, { getXYindex } from "../state/gameState";
import Phaser from "phaser";
import { BOARD_SIZE, layerDepthDiff } from "../constants";
import { EntityKind, PressurePlate } from "../state/entityKinds";

export default class PressurePlateEntity extends BaseEntity {
  private sprite: Phaser.GameObjects.Sprite;
  constructor(
    gameState: GameState,
    scene: Phaser.Scene,
    x: number,
    y: number,
    triggerId: number
  ) {
    super(gameState, scene);

    this.sprite = this.scene.add.sprite(
      x * BOARD_SIZE,
      y * BOARD_SIZE,
      "atlas",
      "Placeholders/temp_button_up1"
    );

    const entity: PressurePlate = {
      kind: EntityKind.PressurePlate,
      x,
      y,
      id: this.id,
      triggerId,
    };

    gameState.silentMutateGameState((state) => {
      this.idx = getXYindex(x, y);
      state.board[this.idx].push(entity);
    });
    this.sprite.setDepth(y + layerDepthDiff.BUTTON);
  }
}
